/**
 * Ref-based session registry for the schedule editor. ScheduleEditor registers a
 * mutable session ref on mount; descendant hooks read from it without needing those
 * values on `<Bound>` (which would re-render the whole tree on every parent update).
 *
 * Cross-cutting updates use scoped events from schedule-editor-event-definitions.mjs.
 */
const sessions = new Map()

export function registerScheduleEditorSession(draftId, sessionRef) {
    if (!draftId || !sessionRef) return
    sessions.set(draftId, sessionRef)
}

export function unregisterScheduleEditorSession(draftId) {
    if (!draftId) return
    sessions.delete(draftId)
}

export function getScheduleEditorSessionRef(draftId) {
    return sessions.get(draftId) ?? null
}

export function readScheduleEditorSession(draftId) {
    return sessions.get(draftId)?.current ?? null
}
